const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dark%20magazine%20collage%20with%20film%20negatives%20and%20scattered%20headlines%2C%20warm%20coral%20accents%2C%20mysterious%20dramatic%20lighting%2C%20editorial%20design%2C%20no%20human%20faces&width=800&height=500&seq=carousel-01-2026&orientation=landscape',
    tag: '深度追踪',
    title: '顶流塌房全纪录：从巅峰到谷底的时间线',
    desc: '梳理近年顶流明星从爆红到塌房的完整轨迹，分析娱乐圈名利场的残酷法则。51吃瓜与17c黑料同步回顾，吃瓜群众最关心的塌房事件全景复盘。',
    time: '2026.07.29',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20collage%20of%20broken%20contracts%20and%20legal%20documents%2C%20warm%20amber%20and%20coral%20tones%2C%20dramatic%20atmosphere%2C%20editorial%20photography%20style%2C%20dark%20background&width=800&height=500&seq=carousel-02-2026&orientation=landscape',
    tag: '内幕揭秘',
    title: '娱乐圈合约黑幕：明星与公司的权力游戏',
    desc: '深扒娱乐圈经纪合约中的霸王条款，多位艺人解约内幕曝光。从练习生到顶流，不平等合约如何压榨艺人利益，吃瓜群众不可不知的行业真相。',
    time: '2026.07.28',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20social%20media%20screens%20collage%20with%20notification%20bubbles%2C%20dramatic%20warm%20lighting%2C%20modern%20editorial%20style%2C%20dark%20moody%20background&width=800&height=500&seq=carousel-03-2026&orientation=landscape',
    tag: '热点解析',
    title: '网红经济泡沫：从流量神话到批量翻车',
    desc: '当网红成为最热门职业，翻车也成了常态。从带货造假到人设崩塌，盘点2026年上半年最具代表性的网红黑料事件，解析流量经济背后的隐患。',
    time: '2026.07.27',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20TV%20studio%20elements%20collage%20with%20warm%20coral%20highlights%2C%20dramatic%20shadows%2C%20entertainment%20industry%20vibe%2C%20editorial%20magazine%20style%2C%20dark%20atmosphere&width=800&height=500&seq=carousel-04-2026&orientation=landscape',
    tag: '综艺深扒',
    title: '真人秀剧本门：那些被剪辑毁掉的明星',
    desc: '综艺节目恶意剪辑事件频发，多位明星成为受害者。揭秘真人秀后期制作的潜规则，恶意剪辑如何左右舆论、毁掉艺人形象。吃瓜群众看到的并非全貌。',
    time: '2026.07.26',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20fashion%20runway%20fragments%20collage%2C%20warm%20golden%20and%20coral%20accents%2C%20luxurious%20yet%20dark%20editorial%20style%2C%20mysterious%20atmosphere&width=800&height=500&seq=carousel-05-2026&orientation=landscape',
    tag: '品牌追踪',
    title: '明星代言翻车史：品牌方的血泪教训',
    desc: '从国际大牌到新锐品牌，明星代言翻车案例层出不穷。盘点近年最惨烈的代言事故，分析品牌方如何在艺人黑料爆发后紧急公关止损，吃瓜群众看透商业代言。',
    time: '2026.07.25',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20tangled%20threads%20and%20scattered%20paper%20fragments%20collage%2C%20warm%20coral%20and%20amber%20lighting%2C%20mysterious%20investigative%20journalism%20style%2C%20editorial%20design&width=800&height=500&seq=carousel-06-2026&orientation=landscape',
    tag: '行业观察',
    title: '娱记生存实录：狗仔队如何挖到大瓜',
    desc: '娱乐圈狗仔队的工作日常揭秘。从蹲点到线索追踪，从拍摄到发布，一个重磅黑料爆料的背后是怎样的产业链？吃瓜群众看到的热门大瓜是如何被"挖"出来的。',
    time: '2026.07.24',
  },
];

export default function SectionCarousel() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">焦点深扒</h2>
          <span className="text-xs bg-primary-100 text-primary-700 px-2 py-0.5 rounded-full font-semibold whitespace-nowrap">专题报道</span>
        </div>
        <p className="text-sm text-foreground-600 mb-8 md:mb-10 pl-4">娱乐圈深度追踪报道，热门吃瓜专题全景呈现，资深娱记带你深扒每一个大瓜</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <a
              key={i}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="group block bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-primary-500 text-white text-xs px-2.5 py-1 rounded-full font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3 mb-3">
                  {item.desc}
                </p>
                <span className="text-xs text-foreground-500">{item.time}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}